import React from 'react';
import styled from 'styled-components';

export const Loader = () => {
  return (
    <>
      <Container>
        <LoaderWrapper>
          <LoaderCircles></LoaderCircles>
        </LoaderWrapper>
      </Container>
    </>
  );
};

const Container = styled.div`
  background-color: #4e4e7550;
  position: fixed;
  z-index: 99;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoaderWrapper = styled.div``;
const LoaderCircles = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 20px;

  ::before {
    content: '';
    color: white;
    height: 50px;
    width: 50px;
    background: transparent;
    border-radius: 50%;
    border: 10px dotted #fda800;
    border-left-color: transparent;
    animation: load5 1s infinite ease-in-out;
  }

  @keyframes load5 {
    40% {
      transform: rotatez(-180deg);
      border-width: 16px;
    }
    80% {
      transform: rotatez(-360deg);
    }
    100% {
      transform: rotatez(-360deg);
    }
  }
`;
